import React, { Component } from 'react'
import { connect } from 'react-redux'

import {
  loadInstructors,
  saveInstructors,
  deleteInstructors,
  clearAjaxCall
} from '../actions/Instructors'

import DualRing from './DualRing'
import Error from './Error'
import AjaxSpinner from './AjaxSpinner'

import InstructorDetails from './Instructors/InstructorDetails'
import EditInstructor from './Instructors/EditInstructor'
import DeleteInstructor from './Instructors/DeleteInstructor'

import { grantAdmin } from './Utils/Service'

const initialState = {
  showDelete: false,
  showEdit: false,
  instructor: {}
}

class Instructors extends Component {
  constructor() {
    super()
    this.showDelete = this.showDelete.bind(this)
    this.showEdit = this.showEdit.bind(this)
    this.hideModal = this.hideModal.bind(this)
    this.escFunction = this.escFunction.bind(this)
    this.state = initialState
  }
  escFunction(event) {
    if (event.keyCode === 27) {
      this.hideModal()
    }
  }
  componentWillMount() {
    if (this.props.instructors.list === null) {
      this.reloadInstructors()
    }
  }
  showDelete(instructor) {
    this.setState({ showDelete: true, instructor })
  }
  showEdit(instructor) {
    this.setState({ showEdit: true, instructor })
  }
  newInstructor() {
    this.setState({
      showEdit: true,
      instructor: {
        id: null,
        name: '',
        email: '',
        password: '',
        grant: 1
      }
    })
  }
  hideModal() {
    this.setState({
      showDelete: false,
      showEdit: false
    })
  }
  reloadInstructors() {
    this.props.loadInstructors()
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.instructors.ajaxSpinner &&
      !this.props.instructors.ajaxSpinner &&
      this.props.instructors.ajaxStatus === null
    ) {
      this.hideModal()
    }
    if (
      prevProps.instructors.ajaxSpinner &&
      !this.props.instructors.ajaxSpinner &&
      this.props.instructors.ajaxStatus !== null
    ) {
      setTimeout(() => {
        this.props.clearAjaxCall('')
      }, 3000)
    }
  }
  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false)
  }
  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false)
  }
  render() {
    const { list, error, loading, ajaxSpinner } = this.props.instructors
    return (
      <div>
        <div className='page-header'>
          <div className='ph-title'>Istruttori</div>
          <div className='ph-descr txt'>
            Gli Istruttori hanno accesso alla console di gestione.
            <br />I permessi sono di 3 tipi:
            <ul className='ul-standard'>
              <li>Ospite: solo visualizzazione</li>
              <li>Utente: visualizzazione e modifica dei dati personali</li>
              <li>Amministratore: permessi completi</li>
            </ul>
          </div>
          <ul className='ph-btn'>
            {grantAdmin() && (
              <li>
                <button
                  onClick={() => this.newInstructor()}
                  className='lnk-tools'
                >
                  <i className='fas fa-user-plus'></i> aggiungi
                </button>
              </li>
            )}
            <li>
              <button
                onClick={() => this.reloadInstructors()}
                className='lnk-tools'
              >
                <i className='fas fa-redo-alt'></i> ricarica
              </button>
            </li>
          </ul>
          <div className='ph-count'>
            {list !== null &&
              list.length + (list.length === 1 ? ' risultato' : ' risultati')}
            {list === null && <i className='fas fa-sync fa-spin'></i>}
          </div>
        </div>
        {loading && <DualRing />}
        {error && <Error error={error} />}
        {list !== null &&
          list.map((i, index) => {
            return (
              <InstructorDetails
                key={index}
                instructor={i}
                showDelete={this.showDelete}
                showEdit={this.showEdit}
              />
            )
          })}
        {this.state.showEdit && (
          <EditInstructor
            instructor={this.state.instructor}
            hideModal={this.hideModal}
          />
        )}
        {this.state.showDelete && (
          <DeleteInstructor
            instructor={this.state.instructor}
            hideModal={this.hideModal}
          />
        )}
        {ajaxSpinner && <AjaxSpinner />}
      </div>
    )
  }
}

function mapStateToProps(state) {
  return state
}

export default connect(mapStateToProps, {
  loadInstructors,
  saveInstructors,
  deleteInstructors,
  clearAjaxCall
})(Instructors)



// WEBPACK FOOTER //
// ./src/components/Instructors.js